import type { Middleware } from '@reduxjs/toolkit'
import type { RootState } from '../index'
import { setGuestModified } from '../ui/uiSlice'

// User-initiated modifying actions in guest mode. Init-actions (setTasks,
// setProjects, setLists, setLoading, etc.) from createInitialStateWorker are
// excluded — they must not trigger the flag.
const GUEST_MODIFYING_ACTION_TYPES = new Set<string>([
    'tasks/addTaskLocal',
    'tasks/updateTaskLocal',
    'tasks/removeTaskLocal',
    'projects/updateProjectNameSaga',
    'projects/updateProjectDescriptionSaga',
    'lists/addListLocal',
    'lists/updateListLocal',
    'lists/removeListLocal',
])

export const guestModifiedMiddleware: Middleware = (store) => (next) => (action: any) => {
    const result = next(action)

    if (GUEST_MODIFYING_ACTION_TYPES.has(action.type)) {
        const state = store.getState() as RootState
        if (!state.auth && !state.ui.isGuestModified) {
            store.dispatch(setGuestModified(true))
        }
    }

    return result
}
